<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Amounts:">
      <div class="minyan-section">
        <div class="styled-radio-container styled-radio-container--ou-donation row">
        <div class="brick__col">
        <div class="level__head amount-row">$200.000 LEVEL</div>
          <div class="amount-row">
            <FormLabel :for="`amount${amounts[0][0]}`" class="input__disabled">
              <span class="label-description" v-html="amounts[0][1]"></span>
            </FormLabel>
          </div>
          <div class="level__head amount-row">$175.000 LEVEL</div>
          <div class="amount-row">
            <input
              :id="`1amount${amounts[1][0]}`"
              type="radio"
              class="amount" name="amount"
              @click="selectedAmount = amounts[1][0]"
            />
            <FormLabel :for="`1amount${amounts[1][0]}`">
              <span class="label-description" v-html="amounts[1][1]"></span>
            </FormLabel>
          </div>
          <div class="amount-row sadads">
            <input
              :id="`2amount${amounts[2][0]}`"
              type="radio"
              class="amount" name="amount"
              @click="selectedAmount = amounts[2][0]"
            />

            <FormLabel :for="`2amount${amounts[2][0]}`">
              <span class="label-description" v-html="amounts[2][1]"></span>
            </FormLabel>
          </div>
          <div class="level__head amount-row">$150.000 LEVEL</div>
          <div class="amount-row">
            <input
              :id="`3amount${amounts[3][0]}`"
              type="radio"
              class="amount" name="amount"
              @click="selectedAmount = amounts[3][0]"
            />
            <FormLabel :for="`3amount${amounts[3][0]}`">
              <span class="label-description"  v-html="amounts[3][1]"></span>
            </FormLabel>
          </div>
          <div class="level__head amount-row">$100.000 LEVEL</div>
          <div class="amount-row">
            <input
              :id="`4amount${amounts[4][0]}`"
              type="radio"
              class="amount" name="amount"
              @click="selectedAmount = amounts[4][0]"
            />
            <FormLabel :for="`4amount${amounts[4][0]}`">
              <span class="label-description" v-html="amounts[4][1]"></span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`5amount${amounts[5][0]}`"
              type="radio"
              class="amount" name="amount"
              @click="selectedAmount = amounts[5][0]"
            />
            <FormLabel :for="`5amount${amounts[5][0]}`">
              <span class="label-description" v-html="amounts[5][1]"></span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`6amount${amounts[6][0]}`"
              type="radio"
              class="amount" name="amount"
              @click="selectedAmount = amounts[6][0]"
            />
            <FormLabel :for="`6amount${amounts[6][0]}`">
              <span class="label-description" v-html="amounts[6][1]"></span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`7amount${amounts[7][0]}`"
              type="radio"
              class="amount" name="amount"
              @click="selectedAmount = amounts[7][0]"
            />
            <FormLabel :for="`7amount${amounts[7][0]}`">
              <span class="label-description" v-html="amounts[7][1]"></span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`8amount${amounts[8][0]}`"
              type="radio"
              class="amount" name="amount"
              @click="selectedAmount = amounts[8][0]"
            />
            <FormLabel :for="`8amount${amounts[8][0]}`">
              <span class="label-description" v-html="amounts[8][1]"></span>
            </FormLabel>
          </div>
          <div class="level__head amount-row">$75,000 LEVEL</div>

          <div class="amount-row">
            <input
              :id="`9amount${amounts[9][0]}`"
              type="radio"
              class="amount" name="amount"
              @click="selectedAmount = amounts[9][0]"
            />
            <FormLabel :for="`9amount${amounts[9][0]}`">
              <span class="label-description" v-html="amounts[9][1]"></span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`amount${amounts[10][0]}`"
              type="radio"
              class="amount" name="amount"
              @click="selectedAmount = amounts[10][0]"
            />
            <FormLabel :for="`amount${amounts[10][0]}`">
              <span class="label-description" v-html="amounts[10][1]"></span>
            </FormLabel>
          </div>
          <div class="level__head amount-row">$50,000 LEVEL</div>
          <div class="amount-row">
            <input
              :id="`amount${amounts[11][0]}`"
              type="radio"
              class="amount" name="amount"
              @click="selectedAmount = amounts[11][0]"
            />
            <FormLabel :for="`amount${amounts[11][0]}`">
              <span class="label-description" v-html="amounts[11][1]"></span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`amount${amounts[12][0]}`"
              type="radio"
              class="amount" name="amount"
              @click="selectedAmount = amounts[12][0]"
            />
            <FormLabel :for="`amount${amounts[12][0]}`">
              <span class="label-description" v-html="amounts[12][1]"></span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`amount${amounts[13][0]}`"
              type="radio"
              class="amount" name="amount"
              @click="selectedAmount = amounts[13][0]"
            />
            <FormLabel :for="`amount${amounts[13][0]}`">
              <span class="label-description" v-html="amounts[13][1]"></span>
            </FormLabel>
          </div>
          <div class="amount-row">
  <input
    :id="`amount${amounts[14][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[14][0]"
  />
  <FormLabel :for="`amount${amounts[14][0]}`">
    <span class="label-description" v-html="amounts[14][1]"></span>
  </FormLabel>
</div>
<div class="level__head amount-row">$36,000 LEVEL</div>

<div class="amount-row">
  <input
    :id="`amount${amounts[15][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[15][0]"
  />
  <FormLabel :for="`amount${amounts[15][0]}`">
    <span class="label-description" v-html="amounts[15][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[16][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[16][0]"
  />
  <FormLabel :for="`amount${amounts[16][0]}`">
    <span class="label-description" v-html="amounts[16][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[17][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[17][0]"
  />
  <FormLabel :for="`amount${amounts[17][0]}`">
    <span class="label-description" v-html="amounts[17][1]"></span>
  </FormLabel>
</div>
</div>
<div class="brick__col">
<div class="level__head amount-row">$25,000 LEVEL</div>

<div class="amount-row">
  <input
    :id="`amount${amounts[18][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[18][0]"
  />
  <FormLabel :for="`amount${amounts[18][0]}`">
    <span class="label-description" v-html="amounts[18][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[19][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[19][0]"
  />
  <FormLabel :for="`amount${amounts[19][0]}`">
    <span class="label-description" v-html="amounts[19][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[20][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[20][0]"
  />
  <FormLabel :for="`amount${amounts[20][0]}`">
    <span class="label-description" v-html="amounts[20][1]"></span>
  </FormLabel>
</div>

<div class="level__head amount-row">$18,000 LEVEL</div>

<div class="amount-row">
  <input
    :id="`amount${amounts[21][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[21][0]"
  />
  <FormLabel :for="`amount${amounts[21][0]}`">
    <span class="label-description" v-html="amounts[21][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[22][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[22][0]"
  />
  <FormLabel :for="`amount${amounts[22][0]}`">
    <span class="label-description" v-html="amounts[22][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[23][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[23][0]"
  />
  <FormLabel :for="`amount${amounts[23][0]}`">
    <span class="label-description" v-html="amounts[23][1]"></span>
  </FormLabel>
</div>
<div class="level__head amount-row">$10,000 LEVEL</div>

<div class="amount-row">
  <input
    :id="`amount${amounts[24][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[24][0]"
  />
  <FormLabel :for="`amount${amounts[24][0]}`">
    <span class="label-description" v-html="amounts[24][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[25][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[25][0]"
  />
  <FormLabel :for="`amount${amounts[25][0]}`">
    <span class="label-description" v-html="amounts[25][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[26][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[26][0]"
  />
  <FormLabel :for="`amount${amounts[26][0]}`">
    <span class="label-description" v-html="amounts[26][1]"></span>
  </FormLabel>
</div>
<div class="level__head amount-row">$5,000 LEVEL</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[27][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[27][0]"
  />
  <FormLabel :for="`amount${amounts[27][0]}`">
    <span class="label-description" v-html="amounts[27][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[28][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[28][0]"
  />
  <FormLabel :for="`amount${amounts[28][0]}`">
    <span class="label-description" v-html="amounts[28][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[29][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[29][0]"
  />
  <FormLabel :for="`amount${amounts[29][0]}`">
    <span class="label-description" v-html="amounts[29][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[30][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[30][0]"
  />
  <FormLabel :for="`amount${amounts[30][0]}`">
    <span class="label-description" v-html="amounts[30][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[31][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[31][0]"
  />
  <FormLabel :for="`amount${amounts[31][0]}`">
    <span class="label-description" v-html="amounts[31][1]"></span>
  </FormLabel>
</div>
<div class="level__head amount-row">$3,600 LEVEL</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[32][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[32][0]"
  />
  <FormLabel :for="`amount${amounts[32][0]}`">
    <span class="label-description" v-html="amounts[32][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[33][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[33][0]"
  />
  <FormLabel :for="`amount${amounts[33][0]}`">
    <span class="label-description" v-html="amounts[33][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[34][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[34][0]"
  />
  <FormLabel :for="`amount${amounts[34][0]}`">
    <span class="label-description" v-html="amounts[34][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[35][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[35][0]"
  />
  <FormLabel :for="`amount${amounts[35][0]}`">
    <span class="label-description" v-html="amounts[35][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[36][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[36][0]"
  />
  <FormLabel :for="`amount${amounts[36][0]}`">
    <span class="label-description" v-html="amounts[36][1]"></span>
  </FormLabel>
</div>
<div class="amount-row">
  <input
    :id="`amount${amounts[37][0]}`"
    type="radio"
    class="amount" name="amount"
    @click="selectedAmount = amounts[37][0]"
  />
  <FormLabel :for="`amount${amounts[37][0]}`">
    <span class="label-description" v-html="amounts[37][1]"></span>
  </FormLabel>
</div>

</div>

        </div>
      </div>
      <ErrorLabel field="amount" style="text-align: right" />

    </FormSection>
          <FormSection v-if="form.amount">
            <TransactionFee />
          </FormSection>     
          <FormSection title="Notes">
            <FormRow>
              <FormInput type="textarea" class="width-half" field="custom.Notes" />
            </FormRow>
          </FormSection>
          <FormSection title="I would like to be contacted by:">
            <FormRow inline>
              <FormSelect
                field="custom.contact"
                class="width-half"
                style="margin-right: 10px"
              >
                <option value="" disabled selected hidden>Select Option</option>
                <option value="Paul Gallant, Chairperson">Paul Gallant, Chairperson</option>
                <option value="Rabbi Mike Rovinsky">Rabbi Mike Rovinsky</option>
                <option value="Rabbi Yitz Staum">Rabbi Yitz Staum</option>
                <option value="Alana Umansky Minoff">Alana Umansky Minoff</option>
                <option value="Any of the Above">Any of the Above</option>
              </FormSelect>

            </FormRow>
          </FormSection>

          <FormSection>
            <InHonorOf />
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
              <Consent privacy="https://jsu.org/privacy-policy/"/>
            </FormRow>
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
            <FormRow>
                  <NewsletterSubscribe text="Sign me up for newsletter" />
            </FormRow> 
              <br>                
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate Now" />
        </PaymentForm>

        <div class="central__text">For more information contact Rabbi “Mike” Rovinsky, Executive Director JSU St. Louis at <a href="tel:314.498.6279">314.498.6279</a> or <a href="mailto:RabbiMike@jsustl.org">RabbiMike@jsustl.org</a></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch, nextTick } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  data() {
    return {
      view: "welcome",
    };
  },  props: {
    campaign: String,
    nocustom: Boolean,
  },
  setup(props) {
    const { getValue, setValue, form, submit, settings } = usePaymentForm();

    if (props.campaign) {
      setValue("applications.0.campaign", props.campaign);
    }

    const selectedAmount = ref();
    const selectedAllocationAmount = ref();
    const customAmount = ref(form.value.amount);
    const customSelected = ref(false);

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customSelected.value = false;

        customAmount.value = null;

        if (selectedAllocationAmount.value) {
          setValue(
            "amount",
            "" + (parseInt(selectedAmount) + selectedAllocationAmount.value)
          );
        } else {
          setValue("amount", "" + selectedAmount);
        }
      }
    });

    watch(selectedAllocationAmount, (selectedAllocationAmount) => {
      if (selectedAllocationAmount) {
        customSelected.value = false;

        customAmount.value = null;

        if (selectedAmount.value) {
          setValue(
            "amount",
            "" + (parseInt(selectedAllocationAmount) + selectedAmount.value)
          );
        } else {
          setValue("amount", "" + selectedAllocationAmount);
        }
      }
    });

    watch(customSelected, (customSelected) => {
      if (customSelected) {
        selectedAmount.value = null;
        selectedAllocationAmount.value = null;
        setValue("amount", null);
      }
    });

    watch(customAmount, async (customAmount) => {
      if (customAmount) {
        selectedAmount.value = null;
        selectedAllocationAmount.value = null;
        customSelected.value = true;
      }

      // make sure UI has vue has dealt with customSelected and then we'll set the customAmount
      await nextTick();

      if (!selectedAmount.value) {
        setValue("amount", customAmount || null);
      }
      if (!selectedAllocationAmount.value) {
        setValue("amount", customAmount || null);
      }
    });

    function clearOutSelectedValue() {
      selectedAmount.value = null;
      selectedAllocationAmount.value = null;
      setValue("amount", null);
    }

    const amounts = computed(() => {
      const amounts = settings!.amounts! as
        | [number, string][]
        | [Partial<{ [key in Currency]: number }>, string][];

      if (typeof amounts[0][0] == "number") return amounts;

      return (amounts as [
        Partial<{ [key in Currency]: number }>,
        string
      ][]).map(([amounts, label]) => [amounts[form.value.currency!], label]);
    });

    return {
      form,
      amounts,
      getValue,
      selectedAmount,
      selectedAllocationAmount,
      customAmount,
      clearOutSelectedValue,
      customSelected,
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep h2 {
  color: #1e426c;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 25px;
}

::v-deep .form-container.ou-donation-form {
  // max-width: 100%;
}
::v-deep
  .styled-radio-container--ou-donation.styled-radio-container
  input[type="radio"]:checked
  + label {
  background: #1e426c;
}
::v-deep hr {
  background: none;
  box-shadow: none;
  height: 0;
  border: none;
  margin-bottom: 20px;
  border-bottom: 1px solid #efefef;
}

::v-deep .styled-radio--ou-donation.styled-radio .radio-part {
  @media (min-width: 720px) {
    min-width: 33.3%;
    flex: 1;
    max-width: 33.3%;
  }
}

.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 50%;
    max-width: 50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}

::v-deep .control-label{
  text-align: left !important;
}

.central__text{
  text-align: center;
  line-height: normal;
  padding: 20px 0px 10px;
  a{
    color: #1e426c;
  }
}

.selector {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  label {
    font-weight: 400;
    font-size: 20px;
    color: black;
  }
  select {
    max-width: 300px;
    margin-left: 20px;
  }
}
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;

  input[type="radio"] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    display: block;
    height: 100%;
    display: flex;
    overflow: hidden;
    &.input__disabled{
      opacity: 0.7;
      font-style: italic;
      cursor: not-allowed;
    text-decoration: line-through !important;
    &:hover{
      background: none;
      color: inherit;
    }
    }
  }
  input[type="radio"]:checked + label {
    background: #1e426c;
    color: white;
  }
  input[type="radio"]:checked + label .label-amount {
    background: #1e426c;
    border-color: #1e426c;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    position: relative;
    min-width: 22%;
    overflow: hidden;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding-left: 5px;
    flex: 1;
    line-height: 1;
    @media (max-width: 720px) {
      margin-right: 5px;
      margin-left: 5px;
      margin-bottom: 10px;
    }
    &:before {
      content: "$";
      position: absolute;
      padding: 15px 8px;
      border-right: 1px solid #ddd;
      height: 100%;
      background: #f7f7f7;
      text-align: center;
      top: 0px;
      left: 0;
      width: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    input[type="number"] {
      border: none;
      background: #fff;
      margin-left: 70px;
      box-shadow: none;
      max-width: 85%;
    }
  }
}
.amount-row {
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  width: 100%;
  @media (min-width: 720px) {
    // min-width: 49%;
    // max-width: 49%;
  }
}
.amount {
  margin-right: 7px;
}
.label-amount {
  font-weight: bold;
  display: inline-block;
  padding: 10px;
  align-items: center;
  min-width: 70px;
  max-width: 70px;
  justify-content: center;
  background: #f7f7f7;
  height: 100%;
  display: flex;
  border-right: 1px solid #efefef;
}
.amount-row:hover {
  .label-amount {
    border-right: 1px solid #ddd;
    background: #efefef;
  }
}
#amount_other {
  max-width: 200px;
}
.label-description {
  font-weight: normal;
    padding: 1px 11px;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    display: flex;
    font-size: 14px;
    line-height: 1.4;
    flex: 1;
  span{
    margin-left: auto;
  }
}
.minyan-section {
  padding: 0.5rem 0 0;
}

.level__head{
  background: rgb(42,172,227);
background: linear-gradient(90deg, rgba(42,172,227,1) 0%, rgba(190,229,241,1) 100%);
line-height: normal;
    margin-top: 7px;
    text-align: center;
    justify-content: center;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: black;
    padding: 8px 5px;
    font-size: 15px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.brick__col{
  flex: 1;
}

.styled-radio-container.styled-radio-container--ou-donation.row {
    gap: 35px;
}
</style>
